import { ref, watch } from '@vue/composition-api'
import TimeApi from '@/api/v2/utility/Time'

/**
 * 営業日→その営業日に適用される営業時間(サーバの営業時間履歴を時点解決した値)を取得するcomposable。
 *
 * currentClub.openAt/closeAt は「現在の」営業時間のため、営業時間を変更した店舗の
 * 過去営業日の編集でクライアント側の日付境界計算がサーバの解決とズレる。
 * 営業日単位の日付解決はこの値を優先し、取得完了まで・取得失敗時のみ現在値へフォールバックする。
 *
 * レスポンス(snake_case): { business_date, open_at(HH:mm), close_at(HH:mm), beginning_of_day, end_of_day }
 */
const cache = new Map()

export const fetchBusinessHours = async businessDate => {
  if (!businessDate) return null
  if (cache.has(businessDate)) return cache.get(businessDate)

  try {
    const res = await TimeApi.getBusinessHours(businessDate)
    if (res.data.status === 'success' && res.data.data) {
      cache.set(businessDate, res.data.data)

      return res.data.data
    }
  } catch (e) {
    // 取得失敗時は呼び出し側のフォールバック(現在値)に委ねる
  }

  return null
}

/**
 * @param {Ref<string>} businessDateRef 営業日(YYYY-MM-DD)のref
 * @returns {{ businessHours: Ref<object|null> }} 未取得・取得失敗時はnull
 */
export default businessDateRef => {
  const businessHours = ref(null)

  watch(
    () => businessDateRef?.value,
    async newDate => {
      businessHours.value = null
      const resolved = await fetchBusinessHours(newDate)

      // 取得中に営業日が変わった場合は破棄(古い営業日の値で上書きしない)
      if (businessDateRef?.value === newDate) businessHours.value = resolved
    },
    { immediate: true },
  )

  return { businessHours }
}
